import mixpanel from 'mixpanel-browser'
import * as braze from '@braze/web-sdk'

if (import.meta.env.VITE_ENV === 'production') {
  mixpanel.init('16284aed131183bbcc3636aa37385997', {
    record_sessions_percent: 100,
    record_mask_text_selector: '',
    loaded: mixpanel => {
      mixpanel.track('onboarding:start')
    },
  })

  braze.initialize('ff0b5138-b57e-49c0-a0d3-1f66e6d43ce9', {
    baseUrl: 'sdk.iad-06.braze.com',
  })
  braze.wipeData()
  braze.openSession()
}
